var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { deprecated, nonenumerable } from 'core-decorators';
import { promises as jsonld } from 'jsonld';
import { JsonLd } from '../Constants';
import TypeCollection from '../TypeCollection';
const isProcessed = new WeakMap();
export default class default_1 {
    constructor(actualResource) {
        Object.assign(this, actualResource);
        isProcessed.set(this, false);
    }
    get id() {
        const id = this[JsonLd.Id];
        if (typeof id !== 'string') {
            throw new Error('Resource identifier must be a string');
        }
        return id;
    }
    get types() {
        return TypeCollection.create(this[JsonLd.Type]);
    }
    get isAnonymous() {
        return this.id.startsWith('_');
    }
    get _processed() {
        return isProcessed.get(this) || false;
    }
    set _processed(val) {
        isProcessed.set(this, val);
    }
    compact(context = 'https://www.w3.org/ns/hydra/core') {
        return jsonld.compact(this, context);
    }
    /**
     * @deprecated Use method without underscore
     */
    _get(property) {
        return this.get(property);
    }
    get(property, { strict } = { strict: false }) {
        if (typeof this[property] !== 'undefined') {
            // @ts-ignore
            return this[property];
        }
        if (strict) {
            throw new Error(`Value for predicate <${property}> was missing`);
        }
        return null;
    }
    /**
     * @deprecated Use method without underscore
     */
    _getArray(property) {
        return this.getArray(property);
    }
    getArray(property, options = { strict: false }) {
        const values = this.get(property, options);
        if (!values) {
            return [];
        }
        if (Array.isArray(values)) {
            return values;
        }
        return [values];
    }
    getNumber(property, options = { strict: false }) {
        const value = this.get(property, options);
        if (value === null || typeof value === 'undefined') {
            return null;
        }
        if (typeof value === 'number') {
            return value;
        }
        throw new Error(`Expected property '${property}' to be a number but found '${value}'`);
    }
    getString(property, options = { strict: false }) {
        const value = this.get(property, options);
        if (value === null || typeof value === 'undefined') {
            return null;
        }
        if (typeof value === 'string') {
            return value;
        }
        throw new Error(`Expected property '${property}' to be a string but found '${value}'`);
    }
    getBoolean(property, options = { strict: false }) {
        const value = this.get(property, options);
        if (value === null || typeof value === 'undefined') {
            return false;
        }
        if (typeof value === 'boolean') {
            return value;
        }
        throw new Error(`Expected property '${property}' to be a boolean but found '${value}'`);
    }
}
__decorate([
    nonenumerable,
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], default_1.prototype, "id", null);
__decorate([
    nonenumerable,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], default_1.prototype, "types", null);
__decorate([
    nonenumerable,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], default_1.prototype, "isAnonymous", null);
__decorate([
    nonenumerable,
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], default_1.prototype, "_processed", null);
__decorate([
    deprecated('Use method without underscore'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", Object)
], default_1.prototype, "_get", null);
__decorate([
    deprecated('Use method without underscore'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", Array)
], default_1.prototype, "_getArray", null);
//# sourceMappingURL=Resource.js.map